import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { nightOwl } from "@code-surfer/themes";
import "prismjs/components/prism-kotlin";
import "prismjs/components/prism-java";
import "prismjs/components/prism-scala";
import { SplitRight } from 'mdx-deck';
import * as React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  nightOwl: nightOwl,
  SplitRight: SplitRight,
  React: React
};